import {types} from './types';

const setGroupsAction = (payload) => {
    return {
        type: types.SET_GROUPS,
        payload,
      }
}

const setUsersAction = (payload) => {
  return {
      type: types.SET_USERS,
      payload,
    }
}

export {
  setGroupsAction,
  setUsersAction
}